import {Component, Input, OnInit} from '@angular/core';
import {ParceriaService} from "../../../services/nova-parceria/parceria.service";
import {TipoBoolPreenchido, TipoBoolPreenchidoEnum} from "../../../aplicacao/enum/TipoBoolPreenchido.enum";
import {
  CancelarPropostaComponent
} from "../../../modules/pages/listagem-proposta/componentes/cancelar-proposta/cancelar-proposta.component";
import {DeviceDetectorService} from "../../../core/services/device-detector.service";
import {MatDialog} from "@angular/material/dialog";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {NgxSpinnerService} from "ngx-spinner";
import {PropostaService} from "../../../services/proposta.service";
import {ComunicacaoService} from "../../../services/comunicacao.service";
import {Documento, DocumentoEnum} from "../../../aplicacao/enum/documentos.enum";
import {EnvioCndsService} from "../../../services/envio-cnds.service";
import {AlertaService} from "../../../bibliotecaPjus/services/alerta.service";
import {TipoCancelamentoEnum} from "../../../aplicacao/enum/tipo-cancelamentos.enum";
import moment from "moment";

@Component({
  selector: 'app-dados-proposta-drawer',
  templateUrl: './dados-proposta-drawer.component.html',
  styleUrls: ['./dados-proposta-drawer.component.scss']
})
export class DadosPropostaDrawerComponent implements OnInit{

  @Input() listaCancelamento = TipoCancelamentoEnum.getTypes();
  documentos;
  constructor(
    protected deviceDetectorService: DeviceDetectorService,
    protected dialog: MatDialog,
    protected bottomSheet: MatBottomSheet,
    protected parceriaService: ParceriaService,
    protected ngxSpinnerService: NgxSpinnerService,
    protected propostaService: PropostaService,
    protected comunicacaoService: ComunicacaoService,
    protected envioCndsService: EnvioCndsService,
    protected alertaService: AlertaService,
  ) { }

  ngOnInit(): void {}

  cancelarProposta(ev): void {
    const data = {
      propostaId: ev.propostaId,
      listaMotivos: this.listaCancelamento
    };
    if (!this.deviceDetectorService.isMobile()) {
      const dialogRef = this.dialog.open(CancelarPropostaComponent, {
        width: '416px',
        data
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.realizarCancelamento(result);
        }
      });
    } else {
      const bottomSheetRef = this.bottomSheet.open(CancelarPropostaComponent, {
        data
      });

      bottomSheetRef.afterDismissed().subscribe(result => {
        if (result) {
          this.realizarCancelamento(result);
        }
      });
    }
  }

  realizarCancelamento(objCancelar): void {
    this.ngxSpinnerService.show();
    this.propostaService.cancelarProposta(objCancelar).subscribe(
      result => {
        this.ngxSpinnerService.hide();
        this.comunicacaoService.emitirAcao({acao: 'Pesquisar'});
        this.comunicacaoService.emitirAcao({acao: 'DrawerDireita'});
      },
      err => {
        this.ngxSpinnerService.hide();
      }
    );
  }

  fecharDrawer(): void {
    this.comunicacaoService.emitirAcao({acao: 'FecharDrawer'});
  }

  deletarDocumento(documento): void {
    this.ngxSpinnerService.show();
    this.envioCndsService.deletar(documento.nome).subscribe(result => {
      this.alertaService.erro('Documento excluído com sucesso!');

      this.parceriaService.get(this.parceriaService.idProposta).subscribe(result => {
        this.parceriaService.model.documento = result.documento;
      });

    }, error => {

    }, () => {
      this.ngxSpinnerService.hide();
    })
  }

  expandir = false;
  expandirDocumento(): void {
    this.expandir = !this.expandir;
  }

  fechar(): void {
    const data = {
      propostaId: this.parceriaService.idProposta,
      acao: 'DrawerDireita'
    }
    this.comunicacaoService.emitirAcao(data);
  }

  filtroDocumento(): any[] {
   return this.parceriaService.model.documento.filter( el => el.tipo !== Documento.PropostaParceiroNegociador);
  }

  transformeData(dataVencimento: string | Date): string {
    if (!dataVencimento) return '';

    const hoje = moment();
    const vencimento = moment(dataVencimento);
    const diff = vencimento.diff(hoje, 'days');

    if (diff > 1) {
      return `Vencimento em ${diff} dias`;
    } else if (diff === 1) {
      return `Vencimento em 1 dia`;
    } else if (diff === 0) {
      return 'Vence hoje';
    } else {
      return `Vencido há ${Math.abs(diff)} dias`;
    }
  }
  protected readonly TipoBoolPreenchidoEnum = TipoBoolPreenchidoEnum;
  protected readonly TipoBoolPreenchido = TipoBoolPreenchido;
  protected readonly DocumentoEnum = DocumentoEnum;
}
